// GENERATED from ez-tree preset "Pine Small" — Scripts/EzTree/PresetConverter.js
// Rerun (to see the drift vs. upstream ez-tree): npm start client.eztree.convertPresets
// NOT read-only: hand tweaks are expected; the converter is just the starting point.
//
// Sizing: targetHeight (metres) is THE scale knob — the generator scales the mesh uniformly to
// that height (unset = the root's default). value = rawHeight × ezTreeUnitToMeters, so the preset
// keeps its natural proportions (× 1.1 on value = +10% overall size); `swing` varies the height
// ±its fraction across the kind's variants. Both numbers are meant to be hand-tweaked.
// footprintRadiusRatio = observed width / observed height; resolved footprint radius =
// targetHeight × footprintRadiusRatio (so resizing via targetHeight keeps width proportional).
import {SceneryKindDef} from "../../@SceneryTypes.js";
import {EZTREE_ROOT_KIND_ID} from "../Kind_EzTree.js";

export const PineSmall_KIND_ID = "ezTree_PineSmall";

export const PineSmallKind = new SceneryKindDef({
	id: "ezTree_PineSmall",
	name: "Pine Small",
	baseKindID: EZTREE_ROOT_KIND_ID,
	// Only the flat keys differing from the root's defaults (TreeOptions ctor defaults) are set —
	// everything else inherits the root.
	paramOverrides: {
		"branchLevels": 1,
		"branchAngle1": 117,
		"branchChildren0": 91,
		"branchGnarliness0": 0.05,
		"branchGnarliness1": 0.08,
		"branchGnarliness2": 0,
		"branchGnarliness3": 0,
		"branchLength0": 39.55,
		"branchLength1": 12.12,
		"branchRadius0": 0.55,
		"branchRadius1": 0.41,
		"branchStart1": 0.16,
		"treeType": "evergreen",
		"leafCount": 21,
		"leafSize": 0.965,
		"leafAlphaTest": 0.3,
		"leafType": "pine",
		"barkType": "Bark003",
		"forceStrength": 0,
		"targetHeight": 10.11,
	},
	footprintRadiusRatio: 0.263,
});
